
import React from 'react';
import { CommonModule, UCAModule } from "uca-react-containers-library";

const ResetPasswordConfirmationComponent = () => {
    return (
        <CommonModule.ViewportProvider>
            <UCAModule.ResetPasswordConfirmation />
        </CommonModule.ViewportProvider>
    );
};

export default ResetPasswordConfirmationComponent;
